import React, { useEffect, useState } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, message, Empty } from 'antd'
// Layout
import { Sidebar } from '../Layout/Sidebar'
// Fragments
import { Header } from '../Fragments/Views/Header'
import { ListViews } from '../Fragments/Views/ListViews'
import { ContentViews } from '../Fragments/Views/ContentViews'
import { Send } from '../Fragments/Views/Send'
import { ListReport } from '../Fragments/Views/ListReport'
import { ViewGraph } from '../Fragments/Views/ViewGraph'
// i18
import { useTranslation } from 'react-i18next'
// Axios
import axios from 'axios'
// Config
import config from '../config'

export const Views = () => {
    const { t } = useTranslation(["translation"]);
    const [addView, setAddView] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate()
        
    function ViewView() {
        
        const [views, setViews] = useState([])
        const [selectView, setSelectView] = useState({})
        const [isGraph, setIsGraph] = useState(false)
        const [loading, setLoading] = useState(false)
        const [error404, setError404] = useState(false)
        const [page, setPage] = useState(1)
        const [total, setTotal] = useState(0)
        
        const apiViews = async() => {
            var pageNew = 0
            if(page <= 0) {
                pageNew = 0
            }
            else {
                pageNew = (page*10)-10
            }

            setLoading(true)
            try {
                const res = await axios.get(`${config.urlApi}/private/views?skip=${pageNew}`, {
                    withCredentials: true,
                })
                if(res.status === 200) {
                    setViews(res.data.data)
                    setSelectView(res.data.data[0])
                    setTotal(res.data.num_items)
                    setLoading(false)
                }
            }
            catch (error) {
                setLoading(false)
                if (error.status === 401) {
                    navigate("/")
                }
                else if (error.status === 404) {
                    return
                }
                else {
                    messageApi.error(t("error_list_view"))
                }
            }
        }
        
        useEffect(() => {
            apiViews()
        }, [addView, page])

        return (
            <Flex>
                {(views.length===0 && !loading)
                    ?
                    <Flex justify="center" style={{ width: "100%", marginTop: "10px" }}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("empty_list_view")} />
                    </Flex>
                    :
                    <>
                        <ListViews views={views} selectView={selectView} setSelectView={setSelectView} setIsGraph={setIsGraph} loading={loading} setError404={setError404} page={page} setPage={setPage} total={total} />
                        <ContentViews t={t} selectView={selectView} isGraph={isGraph} setIsGraph={setIsGraph} apiViews={apiViews} error404={error404} setError404={setError404} />
                    </>
                }
            </Flex>
        )
    }

    function AddView() {

        const [views, setViews] = useState([])
        const [reports, setReports] = useState([])
        const [page, setPage] = useState(1)
        const [total, setTotal] = useState(0)
        const [loading, setLoading] = useState(false)

        const apiReports = async() => {
            setLoading(true)

            var pageNew = 0
            if(page <= 0) {
                pageNew = 0
            }
            else {
                pageNew = (page*10)-10
            }

            try {
                const res = await axios.get(`${config.urlApi}/private/report?skip=${pageNew}`, {
                    withCredentials: true,
                })
                if(res.status === 200) {
                    setReports(res.data.data)
                    setTotal(res.data.num_items)
                    setLoading(false)
                }
            }
            catch (error) {
                setLoading(false)
                if (error.status === 401) {
                    navigate("/")
                }
                else {
                    messageApi.error(t("error_list_report"))
                }
            }
        }
        useEffect(() => {
            apiReports()
        }, [page])

        return (
            <Flex vertical>
                <Send t={t} views={views} setAddView={setAddView} />

                <Flex style={{ width: "100%", height: "calc(100vh - 120px)" }}>
                    <ListReport t={t} reports={reports} views={views} setViews={setViews} setReports={setReports} page={page} setPage={setPage} total={total} loading={loading} />
                    <ViewGraph views={views} />
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex>
            <Sidebar />

            <Flex vertical style={{ width: "calc(100% - 250px)", height: "100vh", padding: "0 15px" }}>
                <Header t={t} addView={addView} setAddView={setAddView} />

                {addView
                    ? <AddView />
                    : <ViewView />
                }
            </Flex>

            {contextHolder}
        </Flex>
    )
}
